module.exports = __webpack_public_path__ + "media/src/img/arrow-right-d647bed8c2d803a21b21414b5f201cba.svg";